export const apiRoot = 'https://eouve.com.br/api';

export const getIdCidade = () => localStorage.getItem('@eouve/id-cidade');
export const getIdCidadeEcrie = () => localStorage.getItem('@eouve/idEcrie-cidade');
export const getIdCidadeEsipe = () => localStorage.getItem('@eouve/idEsipe-cidade');
export const getNomeCidade = () => localStorage.getItem('@eouve/nome-cidade');

export const setCidade = async ({
  Id, IdeCrie, IdeSipe, Campo,
}) => {
  await localStorage.setItem('@eouve/id-cidade', Id);
  await localStorage.setItem('@eouve/idEcrie-cidade', IdeCrie);
  await localStorage.setItem('@eouve/idEsipe-cidade', IdeSipe);
  await localStorage.setItem('@eouve/nome-cidade', Campo);
};

export const getTotem = () => localStorage.getItem('@eouve/totem');

export const setTotem = async (totem) => {
  await localStorage.setItem('@eouve/totem', totem);
};

export const getAuthToken = () => localStorage.getItem('@eouve/authorization-token');

export const setAuthToken = (token) => localStorage.setItem('@eouve/authorization-token', token || '');

export const getDefaultHeaders = async () => ({
  'Content-Type': 'application/json;charset=UTF-8',
  Authorization: `bearer ${await localStorage.getItem('@eouve/authorization-token')}`,
});

export const getDefaultHeadersUpload = async () => ({
  Authorization: `bearer ${await localStorage.getItem('@eouve/authorization-token')}`,
});

export const apiFactory = (path, { plaintext, ...settings }) => fetch(`${apiRoot}${path}`, settings)
  .then((resp) => (plaintext ? resp.text() : resp.json()));
